import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import langMsg from '@blade-sxp/search-center/lang/index';
import UploadModal from '@blade/common/components/img-checker/index.vue';
import ContainImg from '@blade-sxp/search-center/pages/components/contain-img.vue';
import colors from '@/styles/color.scss';
import { detectTypes, eventTypes } from '@blade-sxp/search-center/api/index';
import ImgRetrieval from '@blade-sxp/search-center/pages/components/globasearch/components/img-retrieval.vue';
import deviceSelect from '@blade/common/components/device-group-cascader-select/index.vue';
import datePicker from '@blade/common/components/date-time-select/index.vue';
import moment from 'moment';
import Result from '@blade-sxp/search-center/pages/components/attribute-result/result.vue';
import { searchStore } from '@blade-sxp/search-center/store/search';
import { fromPage, queryType } from '@blade-sxp/search-center/interfaces/enum';
import { distinct, parameterType } from '@blade-sxp/search-center/utils/index';
import { LoginModule } from '@blade/common/store/login';
let SearchCenter = class SearchCenter extends Vue {
    visible = false; // 上传图片
    addImage = require('@blade-sxp/search-center/assets/svgs/add.svg');
    bigImgUrl = ''; // 大图
    bigImg = {
        imageUrl: '',
    };
    dialogVisible = false; // 特征提取框
    codeJson = {
        codeType: '',
        parentId: '',
    }; // 脑图类型 核心 || 检索
    loading = false;
    disabled = false;
    colors = colors;
    base64Image = '';
    keyText = '';
    smallImage = [];
    collapseList = []; //
    isIndex = 0;
    plate = '';
    imageName = '';
    form = {
        dates: [moment().subtract('days', 1).format('YYYY-MM-DD HH:mm:ss'), moment().format('YYYY-MM-DD HH:mm:ss')],
        device: [],
        threshold: 90,
        type: 'features',
        featureValue: {},
        attributesObj: {},
        plate: '',
    };
    isJoint = {};
    defaultTime = ['00:00:00', '23:59:59'];
    tabList = []; // 硬狗tab
    imgTab = []; // 图搜tab
    timeTab = []; // 时空
    type = fromPage.TIME_PAGE; // 类型
    automobile = queryType.AUTOMOBILE;
    resultList = []; // 结果数据
    trackType = '';
    total = 0;
    page = 1; // 当前第几页
    featureType = '';
    sort = ''; // 排序类型
    attributeFiltering = {};
    featureList = [];
    faceAndBody = [
        {
            code: queryType.FACE,
            name: this.$t('face'), // 人脸
        },
        {
            code: queryType.FACE_BODY,
            name: this.$t('faceBody'), // 人脸&人体
        },
        {
            code: queryType.PEDESTRIAN,
            name: this.$t('body'), // 人体
        },
        {
            code: queryType.BODY_FACE,
            name: this.$t('bodyFace'), // 人体&人脸
        },
    ];
    dataParameters = {};
    // 大图是否有背景
    get getUploadBg() {
        return !this.bigImgUrl ? this.colors.searchSblack : '';
    }
    get updateTabActive() {
        if (searchStore.tabActive === 'OBJECT_EVERYTHING') {
            // this.featureType = 'OBJECT_ALGO';
        }
        else {
            this.featureType = searchStore.tabActive;
        }
        return searchStore.tabActive;
    }
    get getIsAutomobile() {
        return ((this.type === fromPage.FEATURES_PAGE && this.featureType === this.automobile) ||
            (this.type === fromPage.TIME_PAGE && this.updateTabActive === this.automobile));
    }
    get getEverything() {
        return this.updateTabActive === 'OBJECT_EVERYTHING' && this.featureType !== 'OBJECT_ALGO';
    }
    // 边框颜色选中
    getBorderColor(val, index) {
        return this.isIndex === index ? this.colors.createTaskFrameHover : this.colors.borderItemHover;
    }
    getShowBg(val, index) {
        return this.isIndex === index ? this.colors.searchSblack : '';
    }
    closeImg() {
        this.dialogVisible = false;
    }
    getBase64Img(base64Img, index, list) {
        const targetImgObj = list[index];
        this.$set(targetImgObj, 'imageUrl', base64Img);
    }
    // 特征其他完成
    retrieval(type, data) {
        // 清空回核心节点
        this.codeJson = { codeType: '', parentId: '' };
        this.featureType = data[0].featureType; // 默认第一个
        this.smallImage = data;
        this.bigImgUrl = data[0].imageUrl;
        this.isIndex = 0; // 特征提取完成 下图默认选中第一个
        this.type = fromPage.FEATURES_PAGE;
        this.disabled = true;
        this.closeImg();
        this.getIamgeTab(this.isJoint); // 图搜Tab
        searchStore.updateTabActive(this.featureType); // 选中tab
        this.parameterTypes();
    }
    openImg() {
        this.$refs.upload.base64Image = null; // 关闭清空上传数据
        this.visible = true;
    }
    // 上传成功
    onUpload(base64Image) {
        this.base64Image = base64Image;
        const param = {
            base64Image: base64Image,
        };
        return detectTypes(param).then((res) => {
            res.forEach((item, index) => {
                !item.featureList && (item.featureList = []);
                if (item.featureType === 'OBJECT_ALGO') {
                    item.maxLength = 10;
                    item.checkIndex = 0;
                }
                if (item.featureList) {
                    item.checkIndex = 0;
                }
            });
            this.collapseList = res.reverse();
            this.dialogVisible = true;
            this.base64Image = base64Image;
        });
    }
    checkIndex(index, targetCol) {
        const colData = targetCol;
        const oldCheckIndex = colData?.checkIndex ?? '';
        const targetIndex = oldCheckIndex !== index ? index : '';
        this.$set(colData, 'checkIndex', targetIndex);
    }
    onFeatureChange(val) {
        this.attributeFiltering = val; // 右侧属性过滤数据
        this.page = 1;
        this.parameterTypes();
    }
    // 小图点击
    select(data, index) {
        this.page = 1;
        this.isIndex = index; // 选中当前的索引
        this.bigImgUrl = data.imageUrl; // 给大图 赋值
        this.featureType = data.featureType;
        const featureType = data.featureType !== 'OBJECT_ALGO' ? data.featureType : 'OBJECT_EVERYTHING';
        if (this.disabled)
            return; // 刚上传 右侧不能点击tab
        if (this.type === fromPage.FEATURES_PAGE)
            searchStore.updateTabActive(featureType); // 点击小图 切换右侧tab
        this.form.attributesObj = {};
        this.$refs.child.trans2Option(); // 小图点击切换属性过来
        this.parameterTypes();
    }
    // 右侧tab 点击切换左侧
    activeTab(val) {
        this.page = 1;
        if (val === queryType.FACE_BODY)
            val = queryType.FACE;
        if (val === queryType.BODY_FACE)
            val = queryType.PEDESTRIAN;
        if (val === 'OBJECT_EVERYTHING')
            val = 'OBJECT_ALGO';
        this.attributeFiltering = {};
        if (this.type === fromPage.TIME_PAGE) {
            this.parameterTypes();
        }
        else {
            let isTab = this.smallImage.findIndex((item) => item.featureType === val);
            if (String(isTab) === '-1') {
                this.resultList = [];
                this.total = 0;
                return;
            } // 左侧没有图片 右侧有tab
            this.isIndex = isTab;
            this.bigImgUrl = this.smallImage?.[this.isIndex]?.imageUrl; // 给大图 赋值
            this.parameterTypes();
        }
    }
    // 查询
    onSearch() {
        this.page = 1;
        if (this.disabled)
            searchStore.updateTabActive(this.featureType); // 上传成功，点击查询右侧tab切换
        this.$refs.child.trans2Option(); // 小图点击切换属性过来
        this.parameterTypes();
    }
    // 重置
    reset() {
        this.page = 1;
        this.type = fromPage.TIME_PAGE;
        this.smallImage = [];
        this.bigImgUrl = '';
        this.keyText = '';
        this.form = {
            dates: [moment().subtract('days', 1).format('YYYY-MM-DD HH:mm:ss'), moment().format('YYYY-MM-DD HH:mm:ss')],
            device: [],
            threshold: 90,
            type: 'features',
            plate: '',
            attributesObj: {},
        };
        this.attributeFiltering = {};
        searchStore.updateTabActive(this.timeTab[0].code); // 选中tab
        searchStore.updateTab(this.timeTab);
        // 清空回核心节点
        this.codeJson = { codeType: '', parentId: '' };
        this.parameterTypes();
    }
    // 硬狗权限
    dogPermissions() {
        this.tabList = [];
        const res = LoginModule.hardDogAbility;
        res.map((item) => {
            this.tabList.push({
                code: item?.labels?.[0]?.code,
                name: item?.labels?.[0]?.name,
            });
        });
        this.isJoint = this.tabList.find((ev) => {
            return ev.code === queryType.FACEBODY;
        });
        this.defaultFeature(res); // 属性过滤 先获取
        this.getTimeTab(this.isJoint); // 时空tab
        this.initialParameters();
        this.getIamgeTab(this.isJoint); // 图搜Tab
        this.defaultTab(this.type); // 第一次进默认tab
    }
    // 图搜Tab
    getIamgeTab(val) {
        let arr = [...this.faceAndBody, ...this.tabList];
        // 是否存在联合
        arr = arr.filter((i) => i.code !== queryType.FACEBODY);
        this.imgTab = val ? distinct(arr, 'code') : this.tabList;
        this.imgTab.forEach((item) => {
            item.disabled = false;
        });
        // console.log('this.imgTab', this.imgTab);
        // 判断左侧小图 和右侧tab不对应禁用
        for (let i = 0; i < this.imgTab.length; i++) {
            for (let j = 0; j < this.smallImage.length; j++) {
                if ((this.smallImage[j] &&
                    (this.imgTab[i].code === this.smallImage[j].featureType ||
                        (this.imgTab[i].code === queryType.FACE_BODY && this.smallImage[j].featureType === queryType.FACE) ||
                        (this.imgTab[i].code === queryType.BODY_FACE && this.smallImage[j].featureType === queryType.PEDESTRIAN))) ||
                    (this.imgTab[i].code === queryType.EVERYTHING && this.smallImage[j].featureType === 'OBJECT_ALGO') // 右侧万物解析tab可点
                ) {
                    this.imgTab[i].disabled = true;
                    break;
                }
            }
        }
    }
    // 时空tab
    getTimeTab(val) {
        // 全量数据去重
        const arr = distinct([...this.faceAndBody, ...this.tabList], 'code');
        // 时空不需要联合属性
        const res = arr.filter((ev) => {
            return ev.code !== queryType.FACE_BODY && ev.code !== queryType.BODY_FACE && ev.code !== queryType.FACEBODY;
        });
        // 是否存在联合
        this.timeTab = val ? res : this.tabList;
    }
    defaultTab(type) {
        if (type === fromPage.FEATURES_PAGE) {
            searchStore.updateTab(this.imgTab); // 存储tab
        }
        else if (type === fromPage.TIME_PAGE || type === fromPage.TEXT_PAGE) {
            searchStore.updateTab(this.timeTab); // 存储tab
        }
    }
    initialParameters() {
        // 一键搜索新开页面参数
        let flag = localStorage.getItem('param');
        if (flag) {
            this.$route.params.param = JSON.parse(flag).param;
            this.$route.params.type = JSON.parse(flag).type;
            // 脑图跳转 传参类型 用于添加脑图节点区分
            this.codeJson = JSON.parse(flag)?.codeJson;
            localStorage.setItem('param', '');
        }
        // 初始
        if (this.$route.params.param)
            this.dataParameters = JSON.parse(this.$route.params.param);
        const plate = this.dataParameters?.attributesSearchRequest?.featureList[0].attributeMaps.st_plate_nos; // 车牌
        if (this.$route.params.type)
            this.type = this.$route.params.type; // 类型
        if (this.dataParameters.dateEnd)
            this.form.dates = [this.dataParameters.dateStart, this.dataParameters.dateEnd]; // 时间
        if (this.dataParameters.deviceIdList)
            this.form.device = this.dataParameters.deviceIdList; // 设备
        if (plate)
            this.form.plate = plate.toString();
        // 没有跳转参数
        let feature = !this.$route.params.type
            ? { featureList: [parameterType(this.featureList, this.timeTab[0].code)] }
            : this.dataParameters[`${this.parameter()}`];
        // 时空 图搜参数区分 imageSearchRequest -- 图搜  attributesSearchRequest -- 时空
        this.search({ [`${this.parameter()}`]: feature });
        if (this.type === fromPage.FEATURES_PAGE) {
            this.smallImage = this.dataParameters.imageSearchRequest.featureList;
            this.bigImgUrl = this.dataParameters.imageSearchRequest.featureList[0].imageUrl;
            this.featureType = this.smallImage[0].featureType;
        }
        else if (this.type === fromPage.TEXT_PAGE) {
            this.keyText = this.dataParameters.textTypeSearchRequest.keyText;
        }
        let featureType = feature.featureList ? feature.featureList[0].featureType : feature.featureType;
        if (featureType === 'OBJECT_ALGO') {
            featureType = 'OBJECT_EVERYTHING';
        }
        searchStore.updateTabActive(featureType); // 选中tab
    }
    // 点击查询 参数
    parameterTypes() {
        let data = {};
        let feature = {};
        let featureList = [];
        let featureType = '';
        if (this.type === fromPage.FEATURES_PAGE) {
            searchStore.updateTab(this.imgTab); // 存储tab
            featureList = this.smallImage; // 数据
        }
        else {
            searchStore.updateTab(this.timeTab); // 存储tab
            featureList = this.featureList;
        }
        featureType = this.disabled ? this.featureType : this.updateTabActive;
        if (featureType === 'OBJECT_EVERYTHING' && this.parameter() === 'imageSearchRequest') {
            featureType = 'OBJECT_ALGO';
        }
        console.log('featureType', featureType);
        // 上传图片 选中类型错误updateTabActive
        feature = parameterType(featureList, featureType, this.form.plate, this.attributeFiltering);
        feature.attributeMaps = { ...feature.attributeMaps, ...this.attributeFiltering };
        let threshold = this.parameter() === 'imageSearchRequest' ? { threshold: this.form.threshold / 100 } : {};
        const param = this.parameter();
        if (this.getEverything) {
            data = { textTypeSearchRequest: { ...feature, ...threshold, keyText: this.keyText } };
        }
        else {
            data = { [param]: { featureList: [feature], ...threshold } };
        }
        this.search(data);
    }
    // imageSearchRequest -- 图搜  attributesSearchRequest -- 时空  textTypeSearchRequest -- 文本
    parameter() {
        // if (this.getEverything) {
        //   return 'textTypeSearchRequest';
        // }
        switch (this.type) {
            case fromPage.FEATURES_PAGE:
                return 'imageSearchRequest';
            case fromPage.TEXT_PAGE:
                return 'textTypeSearchRequest';
            default:
                return 'attributesSearchRequest';
        }
    }
    current(val) {
        this.page = val;
        this.parameterTypes();
    }
    changeThreshold(val) {
        this.form.threshold = val;
        this.page = 1;
        this.parameterTypes();
    }
    // 排序
    changeSort(val) {
        this.sort = val;
        this.parameterTypes();
    }
    search(data) {
        this.loading = true;
        // 脑图列表需要添加父级ID parameter返回  imageSearchRequest -- 图搜  attributesSearchRequest -- 时空
        console.log('this.parameter', this.parameter(), data);
        if (data[`${this.parameter()}`]) {
            data[`${this.parameter()}`].parentNodeId = this.codeJson?.parentId ? Number(this.codeJson?.parentId) : 0;
        }
        const param = {
            size: 56,
            page: this.page,
            dateEnd: this.form.dates[1],
            dateStart: this.form.dates[0],
            deviceIdList: this.form.device,
            pageOrderList: [
                {
                    orderField: this.sort,
                },
            ],
            ...data,
        };
        eventTypes(param)
            .then((res) => {
            this.resultList = res.searchList[0].list;
            this.resultList.forEach((item, idx) => {
                item.idIndex = idx;
            });
            this.total = res.searchList[0].total;
            this.trackType = res.searchList[0].trackType;
            if (this.trackType === queryType.FACE_BODY) {
                this.trackType = queryType.FACE;
            }
            if (this.trackType === queryType.BODY_FACE)
                this.trackType = queryType.PEDESTRIAN;
            this.disabled = false;
        })
            .catch(() => {
            this.resultList = [];
            this.total = 0;
        })
            .finally(() => {
            this.loading = false;
        });
    }
    defaultFeature(res) {
        this.featureList = res.map((item) => {
            return {
                attributeMaps: {},
                featureType: item.labels[0].code,
                featureValue: '',
                imageUrl: '',
                version: null,
                name: item.labels[0].name,
            };
        });
    }
    mounted() {
        this.dogPermissions();
    }
};
SearchCenter = __decorate([
    Component({
        name: 'SearchCenter',
        components: { UploadModal, ContainImg, ImgRetrieval, deviceSelect, datePicker, Result },
        i18n: {
            messages: {
                zh: {
                    emptySearchHint: '搜索请求类型不能为空',
                    device: '所有设备',
                    start: '开始时间',
                    end: '结束时间',
                    reset: '重置',
                    search: '搜索',
                    day: '最近一天',
                    week: '最近一周',
                    halfMonth: '最近十五天',
                    searchImage: '以图像搜索',
                    face: '人脸',
                    body: '人体',
                    vehicle: '车辆',
                    faceBody: '人脸&人体',
                    bodyFace: '人体&人脸',
                },
                en: {
                    emptySearchHint: 'The image request or event request must be not null',
                    device: 'All device',
                    start: 'Start',
                    end: 'End',
                    reset: 'Reset',
                    search: 'Search',
                    day: 'Last day',
                    week: 'Last week',
                    halfMonth: 'Last 15 days',
                    searchImage: 'Search by image',
                    face: 'Face',
                    body: 'Body',
                    vehicle: 'Vehicle',
                    faceBody: 'Face&Body',
                    bodyFace: 'Body&Face',
                },
            },
            sharedMessages: langMsg,
        },
    })
], SearchCenter);
export default SearchCenter;
